// src/pages/ViewPlanPage.js

import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { supabase } from '../supabaseClient'
import SidebarLayout from '../components/SidebarLayout'
import PlanOverview from '../components/plan/PlanOverview'
import FinancialSummary from '../components/plan/FinancialSummary'
import PlanDetailsTabs from '../components/plan/PlanDetailsTabs'

function ViewPlanPage() {
  const { groupId } = useParams()
  const [plan, setPlan] = useState(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const fetchPlan = async () => {
      const { data, error } = await supabase
        .from('plans_test')
        .select('*')
        .eq('group_id', groupId)
        .order('last_upload_date', { ascending: false })
        .limit(1)

      if (!error && data?.length > 0) {
        const row = data[0]

        setPlan({
          ...row.parse_result?.parsed,
          benefit_year: row.benefit_year
      })

      }

      setLoading(false)
    }

    fetchPlan()
  }, [groupId])

  if (loading) {
    return (
      <SidebarLayout>
        <p style={{ padding: '2rem' }}>Loading...</p>
      </SidebarLayout>
    )
  }

  if (!plan) {
    return (
      <SidebarLayout>
        <p style={{ padding: '2rem' }}>Plan not found.</p>
      </SidebarLayout>
    )
  }

  return (
    <SidebarLayout>
      <div style={{ padding: '1rem', maxWidth: '1400px', margin: '0 auto', fontFamily: 'system-ui' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1.5rem' }}>
          <h2 style={{ fontSize: '1.5rem', fontWeight: 700, margin: 0 }}>
            📄 Viewing Plan for Group ID: <code>{groupId}</code>
          </h2>
          <button
            onClick={() => window.history.back()}
            style={{
              padding: '0.4rem 0.75rem',
              backgroundColor: '#e2e8f0',
              color: '#1f2937',
              border: '1px solid #cbd5e1',
              borderRadius: '4px',
              fontSize: '0.8rem',
              cursor: 'pointer'
            }}
          >
            ⬅ Back to Plans
          </button>
        </div>

        {/* Two-column static layout */}
        <div style={{ display: 'flex', gap: '2rem', flexWrap: 'wrap', marginBottom: '2rem' }}>
          <div style={{ flex: 1 }}>
            <PlanOverview plan={plan} />
          </div>
          <div style={{ flex: 1 }}>
            <FinancialSummary plan={plan} />
          </div>
        </div>

        {/* Tabs for the rest of the content */}
        <PlanDetailsTabs plan={plan} />
      </div>
    </SidebarLayout>
  )
}

export default ViewPlanPage
